import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaTimesCircle, FaTimes } from "react-icons/fa";

function ProgressBar({ progressData }) {
  const [showPopup, setShowPopup] = useState(true);

  // Hide popup if progress is 100
  useEffect(() => {
    if (progressData?.progress === 100) {
      setShowPopup(false);
    }
  }, [progressData]);

  if (!progressData || !showPopup) return null;

  return (
    <div className="profile-pop-up-container">
      <div className="profile-pop-up">
        {/* Close button */}
        <button
          className="popup-close-btn"
          onClick={() => setShowPopup(false)}
        >
          <FaTimes />
        </button>

        <h4>Complete your Profile</h4>
        <br />
        <progress value={progressData.progress} max="100"></progress>
        <div className="progress-text">{progressData.progress}% completed</div>
        <br />

        <br />
          <a href="/employer/profile" className="normalbtn">
            Complete Profile
          </a>
      </div>
    </div>
  );
}

export default ProgressBar;
